export enum DefaultValidationError {
  Min = 'min',
  Max = 'max',
  Required = 'required',
  Email = 'email',
  Cpu = 'cpu',
  MaxLength = 'maxlength',
  Range = 'range',
  MinLength = 'minlength',
  Pattern = 'pattern',
  Forbidden = 'forbidden',
  Number = 'number',
  Cron = 'cron',
  Ip2 = 'ip2',
  InvalidRegex = 'invalidRegex',
  InvalidStrftimeSpecifier = 'invalidStrftimeSpecifier',
  ContainsSlash = 'containsSlash',
  InvalidCharacters = 'invalidCharacters',
  OrphanedPercent = 'orphanedPercent',
  InvalidRcloneBandwidthLimit = 'invalidRcloneBandwidthLimit',
  SelectionMustBeFile = 'selectionMustBeFile',
  Empty = 'empty',
  ExactLength = 'exactLength',
  MinArrayLength = 'minArrayLength',
  MaxArrayLength = 'maxArrayLength',
}
